
(function () {
  function initCard(card) {
    if (card.dataset.flReady === '1') return;
    const slides = Array.from(card.querySelectorAll('[data-fl-slide]'));
    if (slides.length < 2) return;

    card.dataset.flReady = '1';
    let index = 0;
    let hoverTimer = null;
    const counter = card.querySelector('[data-fl-counter]');
    const media = card.querySelector('[data-fl-media]');

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });
      if (counter) counter.textContent = (index + 1) + '/' + slides.length;
    }

    const prev = card.querySelector('[data-fl-prev]');
    const next = card.querySelector('[data-fl-next]');

    if (prev) prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(index - 1);
    });

    if (next) next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(index + 1);
    });

    if (media) {
      media.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          if (index === 0) show(1);
        }, 180);
      });

      media.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        show(0);
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fl-bd-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
